import { api } from '@/scripts/api';

export const SocialMediaAccountPostService = {
    post(clientId, payload){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/accountpost/${clientId}`;

            api.post(service, payload)
                .then(resolve)
                .catch(reject);
        })
    },

    patch(id, clientId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/accountpost/${id}/${clientId}`;
            
            api.msPatch(service, payload)
                .then(resolve)
                .catch(reject);
        });

    },

    delete(id, clientId){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/accountpost/${id}/${clientId}`;

            api.delete(service)
                .then(resolve)
                .catch(reject);
        })
    },
}